module.exports = __webpack_public_path__ + "img/feedback_safe_manual.7a019412.svg";